import React from "react";
import { useLocation } from "react-router-dom";
import Job1 from "../../assets/images/job-ico1.png";
import Job2 from "../../assets/images/job-ico2.png";
import Job3 from "../../assets/images/job-ico3.png";

export default function ViewJobComp() {
  const { state } = useLocation();
  // console.log("state", state);
  return (
    <section className="view-job pc-p-3">
      <div className="container-fluid px-5">
        <div className="job-detail-box primary-box mt-4">
          <div className="row border-bottom align-items-center pb-3">
            <div className="col-lg-9">
              <div className="primary-heading color-dark">
                <h5 className="mb-5">Job details</h5>
                <h4>{state?.job_title}</h4>
                <p className="tag-p">
                  <span>{state?.term}</span>
                  {/* Posted Sep 6, 2023 */}
                </p>
                <p>{state?.description}</p>
                {/* <p>The ideal candidate would be:</p>
                <ul className="mb-3">
                  <li>Fluent in English - Quick and responsive</li>
                  <li>Able to communicate in Slack</li>
                  <li>
                    Have the ability to take an example or idea and run with it
                  </li>
                  <li>Eager to understand our industry and target audience</li>
                  <li>Creative and recommend new designs we didn't consider</li>
                </ul>
                <p>
                  Mention the word "academy” at the top of your proposal to be
                  considered.
                </p> */}
                <span className="color-secondary a-link">Less</span>
                <span className="color-secondary a-link">View job posting</span>
              </div>
            </div>
            <div className="col-lg-3 border-left">
              <div className="job-specs primary-heading color-dark">
                <div className="job-specs-icon">
                  <img src={Job1} alt="Job Icon" />
                </div>
                <div className="job-specs-content">
                  <h5>{state?.experience_needed}</h5>
                  <p>Experience Level</p>
                </div>
              </div>
              <div className="job-specs primary-heading color-dark">
                <div className="job-specs-icon">
                  <img src={Job2} alt="Job Icon" />
                </div>
                <div className="job-specs-content">
                  <h5>$ {state?.project_budget}</h5>
                  <p>Project Range</p>
                </div>
              </div>
              <div className="job-specs primary-heading color-dark">
                <div className="job-specs-icon">
                  <img src={Job3} alt="Job Icon" />
                </div>
                <div className="job-specs-content">
                  <h5>{state?.length} months</h5>
                  <p>Project Length</p>
                </div>
              </div>
            </div>
          </div>
          <div className="primary-heading color-dark mt-3">
            <h6>Skills</h6>
            <p className="tag-p">
              {state?.skills.map((e) => (
                <span key={e.id}>{e.name}</span>
              ))}
            </p>
          </div>
          {/* <div className="submit_btn mt-5">
            <Link to={CLIENT.jobPost} className="primary-btn primary-bg">
              Submit Your Job
            </Link>
          </div> */}
        </div>
      </div>
    </section>
  );
}
